import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, Dialog, DialogContent, DialogTitle } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import API from '@/utils/axios';
import { useSnackbar } from '@contexts/SnackbarContext';
import PackHistoryTable from '@components/pack/PackHistoryTable';

const PackHistoryDialog = ({ customerId, packId, modalOpen, setModalOpen }) => {
    const { t } = useTranslation();
    const { showMessage } = useSnackbar();
    const [audits, setAudits] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (modalOpen) {
            setLoading(true);
            API.get(`/customers/${customerId}/packs/${packId}/audits`)
                .then(response => {
                    setAudits(response.data);
                    setLoading(false);
                })
                .catch(error => {
                    showMessage(t('Error loading pack history'), 'error');
                    setAudits([]);
                    setLoading(false);
                });
        }
    }, [modalOpen, packId, customerId, showMessage, t]);

    return (
        <Dialog 
            open={modalOpen}
            onClose={() => setModalOpen(false)}
            fullWidth
            maxWidth="md"
        >
            <DialogTitle>
                {t('Pack history')}
                <IconButton
                    aria-label="close"
                    onClick={() => setModalOpen(false)}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <PackHistoryTable loading={loading} audits={audits} />
            </DialogContent>
        </Dialog>
    );
};

export default PackHistoryDialog; 